// Tells a page whether it is being shown because the browser was REFRESHED on it (as opposed to the
// user navigating there, or coming back to it with the Back button).
//
// This module is imported by App.js, so it runs when the document loads — before any lazy page chunk —
// and remembers (once) whether that load was a refresh and which path it landed on.

const getNavigationType = () => {
  try {
    const entry = window.performance.getEntriesByType('navigation')[0];
    if (entry) return entry.type;
    // Older browsers: 1 === TYPE_RELOAD
    return window.performance.navigation && window.performance.navigation.type === 1 ? 'reload' : 'navigate';
  } catch (e) {
    return 'navigate';
  }
};

let pending = getNavigationType() === 'reload';
const landingPath = window.location.pathname;

// True only for the first page shown after a refresh, and only when `pathname` is the page that was
// refreshed. Every later visit (Back, menu links) gets false.
export const consumeReloadLanding = (pathname) => {
  if (!pending) return false;

  pending = false;
  return pathname === landingPath;
};
